import { cn } from "@frontend/shared/lib/utils";
import { forwardRef } from "react";

interface KioskToggleProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "onChange"> {
  checked: boolean;
  onToggle: () => void;
}

export const KioskToggle = forwardRef<HTMLButtonElement, KioskToggleProps>(
  ({ checked, onToggle, className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        onClick={onToggle}
        data-testid="kiosk-toggle"
        className={cn(
          "relative w-[72px] h-8 rounded-full transition-colors",
          checked ? "bg-indigo-900" : "bg-gray-400",
          className,
        )}
        {...props}
      >
        <span
          className={cn(
            "absolute top-[3px] left-[3px] w-[26px] h-[26px] bg-white rounded-full transition-transform",
            checked ? "translate-x-[40px]" : "translate-x-0",
          )}
        />
      </button>
    );
  },
);

KioskToggle.displayName = "KioskToggle";
